import {useParams} from "react-router-dom";
import React, {useEffect} from "react";

import {ActionProvider} from "components/organisms/Bazaar/BazaarCurrentItem/useActionContext";
import {ModalsProvider, DefaultLayout} from "layouts";
import {useGMTEvents} from "hooks";

import {BazaarCurrentItemContainer} from "components/organisms";

const BazaarCurrentItem = () => {
    const viewStart = new Date().getTime()

    const {token_id} = useParams()
    const {viewSpentTimeProcess} = useGMTEvents()

    useEffect(() => () => {
        viewSpentTimeProcess(viewStart, token_id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DefaultLayout>
            <ModalsProvider>
                <ActionProvider>
                    <BazaarCurrentItemContainer/>
                </ActionProvider>
            </ModalsProvider>
        </DefaultLayout>
    )
}

export default BazaarCurrentItem